export const roles = {
  namespaced: true,
  state: {
    role: '',
    allowedRoles: ['evaluator'],
    isValidRole: false,
  },
  mutations: {
    setRole(state, payload) {
      state.role = payload
    },
    setValid(state, payload) {
      state.isValidRole = payload
    },
  },
  actions: {
    async setRole({ commit }, payload) {
      try {
        commit('setRole', payload)
      } catch (err) {
        console.log(err)
      }
    },
    async setValid({ commit }, payload) {
      try {
        commit('setValid', payload)
      } catch (err) {
        console.log(err)
      }
    },
  },
  getters: {
    checkRole: (state) => {
      return state.allowedRoles.includes(state.role) ? true : false
    },
    checkValid: (state) => {
      return state.isValidRole
    },
    getRole: (state) => {
      return state.role
    },
  },
}
